export const BRIDGE_USER_SUCCESS = 'BRIDGE_USER_SUCCESS';
export const BRIDGE_USER_REQUEST = 'BRIDGE_USER_REQUEST';
export const BRIDGE_USER_FAILURE = 'BRIDGE_USER_FAILURE';
